import { NgSelectModule } from '@ng-select/ng-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageConfirmModalComponent } from './components/message-confirm-modal/message-confirm-modal.component';
import { TableComponent } from './components/table/table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { RouterModule } from '@angular/router';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { HeatmapComponent } from './components/heatmap/heatmap.component';
import { CardComponent } from './components/card/card.component';
import { ClickStopPropagation } from './directive/click-stop-propagation.directive';
import { DisplayAssetComponent } from './components/display-asset/display-asset.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommentComponent } from './components/comment/comment.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { RateerComponent } from './components/rateer/rateer.component';
import { QuestionCardComponent } from './components/question-card/question-card.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';



@NgModule({
  declarations: [MessageConfirmModalComponent, TableComponent, AlertMessageComponent, HeatmapComponent, CardComponent, ClickStopPropagation, DisplayAssetComponent, CommentComponent, PaginationComponent, RateerComponent, QuestionCardComponent, PdfViewerComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    NgxDatatableModule,
    RouterModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    UiSwitchModule
  ],
  exports: [
    TranslateModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MessageConfirmModalComponent,
    TableComponent,
    AlertMessageComponent,
    HeatmapComponent,
    CardComponent,
    ClickStopPropagation,
    DisplayAssetComponent,
    PaginationComponent,
    CommentComponent,
    FormsModule,
    NgbModule,
    RateerComponent,
    QuestionCardComponent,
    PdfViewerComponent
  ]
})
export class ShareModule { }
